import React from 'react';
// import TheComponent from '../../environments/lacin/scenes/Craftsman/index';
export default function renderEnvComponent(path, GenericComponent) {
    // ... et renvoie un autre composant...
    return function(props) {
        try {
            const environment = props.environment || props.history.environment;
            const CustomComponent = require(`../../environments/${environment}/${path}`).default;
            if (CustomComponent) {
                console.debug('RENDER CustomComponent', path);
                return <CustomComponent {...props} />;
            }
        } catch (e) {
            return <GenericComponent {...props} />;
        }
    };
}



// WEBPACK FOOTER //
// ./data/common/renderEnvComponent.js